import { Component, Vue } from 'vue-property-decorator';
import { parseRedirectParam, withSellerPrefix } from '@/helpers/route';
@Component({ name: 'Auth0LogoutRoute' })
export default class extends Vue {
    beforeRouteEnter(to, _, next) {
        const redirect = parseRedirectParam(to.query.redirect);
        next(() => {
            window.location.href = withSellerPrefix(redirect ?? '/');
        });
    }
}
